import React from 'react';
import PropTypes from 'prop-types';

import {
  default as Amplify, 
  Auth, 
  Logger
} from 'aws-amplify';

import { 
  fade, 
  makeStyles,
} from '@material-ui/core/styles';

import {
  AppBar,
  Badge,
  IconButton,
  InputBase,
  Toolbar,
  Typography,
} from '@material-ui/core';

import {
  Notifications as NotificationsIcon,
  Search as SearchIcon,
  Menu as MenuIcon,
} from '@material-ui/icons';

import {
  UserBadge,
  UserMenu,
} from "../../user";

Amplify.configure(window['AppConfig']);

const logger = new Logger('ConsoleAppBar');

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 1,
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));


export default function ConsoleAppBar(props) {
  const { user, search, notifications, selectedClientId, onNavMenuClick, onSelectClient } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleNavMenuOpen = (event) => {
    if(onNavMenuClick) {
      onNavMenuClick(event);
    }
  };

  const handleSelectClient = (clientAccountId) => {
    if(onSelectClient) {
      onSelectClient(clientAccountId);
    }
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    handleMenuClose();
    Auth.signOut();
  };

  const menuId = 'primary-search-account-menu';

  return (

    <AppBar position="fixed" className={classes.root}>
      <Toolbar>
        <IconButton color="inherit" onClick={handleNavMenuOpen}>
          <MenuIcon />
        </IconButton>&nbsp;&nbsp;
        <Typography className={classes.title} variant="h6" noWrap>
          Data Lake Console
        </Typography>
        {search?
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div>
        :null}
        <div className={classes.grow} />
        {notifications?
          <IconButton aria-label="show 17 new notifications" color="inherit">
            <Badge badgeContent={17} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        :null}
        <IconButton
          edge="end"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
        >
          <UserBadge userContext={user}/>
        </IconButton>
      </Toolbar>
      <UserMenu
        menuId={menuId}
        userRole={user.role}
        //clients={user.authorizedClients}
        clients={user.clients}
        anchorEl={anchorEl}
        open={isMenuOpen}
        onSelectClient={handleSelectClient}
        onMenuClose={handleMenuClose}
        onSignOut={handleSignOut}
        selectedClientId={selectedClientId}
      />
    </AppBar>
  );
}

ConsoleAppBar.propTypes = {
  user: PropTypes.object,
  search: PropTypes.bool.isRequired,
  selectedClientId: PropTypes.string,
  notifications: PropTypes.bool.isRequired,
  onNavMenuClick: PropTypes.func,
  onSelectClient: PropTypes.func,
};

ConsoleAppBar.defaultProps = {
  search: false,
  notifications: false,
};

